import {makeStyles} from '@material-ui/core/styles';

export const menuElementStyles = makeStyles({
    elementWrapper: {
        display: 'inline-block',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '1.5',
        boxSizing: 'border-box',
        position: 'relative',
        whiteSpace: 'nowrap',
        margin: '0 calc(1.75 * 1em) calc(1.75 * 1em) 0',
        transition: 'all 0.2s',
        padding: '0 5px',
    },
    element: {
        padding: 'calc(1 * 1em)',
        backgroundColor: '#575756',
        fontSize: '12px',
        border: '1px solid',
        borderColor: 'rgb(108,108,107)',
        opacity: '1',
        pointerEvents: 'all',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        height: 'inherit',
        borderRadius: '2px',
        userSelect: 'none',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'box-shadow 0.2s,background-color 0.2s,border-color 0.2s',
        color: 'white',
        alignItems: 'center',
    },
    elementIcon: {
        marginBottom: 'calc(0.75 * 1em)',
        width: '48px',
        display: 'flex',
        flex: '0 0 48px',
        position: 'relative',
        lineHeight: '0',
        alignItems: 'center',
        justifyContent: 'center',
    },
    elementText: {
        color: 'inherit',
        display: 'inline-block',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
        whiteSpace: 'nowrap',
        fontSize: 'inherit',
        fontWeight: 400,
        cursor: 'pointer',
        userSelect: 'none',
        textAlign: 'center',
        textDecoration: 'none',
    },
    link: {
        fontFamily: 'myriad-pro,sans-serif',
        fontSize: '14px',
        color: '#FFFFFF',
        cursor: 'pointer',
        display: 'flex',
        position: 'relative',
        height: '100px',
        width: '110px',
        textDecoration: 'none',
        flexDirection: 'column',
        alignItems: 'center'
    },
    icon: {
        height: '100%',
        width: '100%'
    }
});